import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonSize, ButtonType } from './button.model';

@Component({
  selector: 'signaturit-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  exportAs: 'signaturitButton'
})
export class ButtonComponent implements OnInit, AfterViewInit {

  class: string = 'signaturit_button_primary_md';

  @Input() internalid: string;
  @Input() text: string;
  @Input() type: ButtonType;
  @Input() size: ButtonSize;
  @Input() icon: string;
  @Input() altIcon: string;
  @Input() disabled: boolean = false;
  @Input() showLoader: boolean = false;
  @Input() showLoaderWithText: boolean = false;
  @Input() showNotification: boolean = false;
  @Input() fullWidth: boolean = false;

  @Output() onClick: EventEmitter<null> = new EventEmitter<null>();

  constructor() { }

  ngOnInit(): void {
    if (this.type && this.size) {
      this.class = `signaturit_button_${this.type}_${this.size}`;
    }

    if (this.showLoader) {
      this.disabled = true;
    }
  }

  ngAfterViewInit(): void {
    if (this.fullWidth && this.internalid) {
      document.getElementById(this.internalid).style.width = '100%';
    }
  }

  click(): void {
    this.onClick.emit();
  }

}
